module.exports = __webpack_public_path__ + "static/media/ActionPlanIcon.df142cc4.svg";